// passing the path into variables

const destination1 = '/assets/biaggini/destinations/Arica-Banner.png'
const destination2 = '/assets/biaggini/destinations/Antofagasta-Banner.png'
const destination3 = '/assets/biaggini/destinations/Mejillones-Banner.png'


const destination = [destination1, destination2, destination3];



const biagginiSlides = {
    destination,
}

export default biagginiSlides


// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/biagginiSlides.js